import { render, staticRenderFns } from "./CooperationModal.vue?vue&type=template&id=71b37dc2&"
import script from "./CooperationModal.vue?vue&type=script&lang=js&"
export * from "./CooperationModal.vue?vue&type=script&lang=js&"
import style0 from "./CooperationModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports